import { render, staticRenderFns } from "./Bizs.vue?vue&type=template&id=8c5739e6&lang=pug"
import script from "./Bizs.vue?vue&type=script&lang=js"
export * from "./Bizs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports